import React from 'react'

import DepartmentManagerIcon from '~/assets/components/what-we-do-cards/department-manager.svg'
import ElectedOfficialsIcon from '~/assets/components/what-we-do-cards/elected-officials.svg'
import EmployeeIcon from '~/assets/components/what-we-do-cards/employee.svg'
import ResidentIcon from '~/assets/components/what-we-do-cards/residents.svg'
import Employee from '~/assets/pages/city/setup/cities-delight/cities-delight-1.jpg'
import Residents from '~/assets/pages/city/setup/cities-delight/cities-delight-2_2.jpg'
import DepartmentManager from '~/assets/pages/city/setup/elected-officials-managers/elected-officials-managers-3.jpg'
import ElectedOfficials from '~/assets/pages/city/setup/elected-officials/elected-officials-2.jpg'
import CardRow from '~/components/common/CardRow'
import CardRowItem from '~/components/common/CardRowItem'
import translate from '~/locale'

const WhatWeDoCards: React.FC = () => {
  const cards = [
    {
      image: Residents,
      icon: ResidentIcon,
      title: 'residents_live',
      text: 'residents_are_the_heart',
    },
    {
      image: ElectedOfficials,
      icon: ElectedOfficialsIcon,
      title: 'electedofficial',
      text: 'elected_by_residents',
    },
    {
      image: DepartmentManager,
      icon: DepartmentManagerIcon,
      title: 'user_deparmentmanager',
      text: 'department_managers_plan',
    },
    {
      image: Employee,
      icon: EmployeeIcon,
      title: 'employee',
      text: 'municipal_employees_heros',
    },
  ]

  return (
    <CardRow columns={4}>
      {cards.map((card, key) => (
        <CardRowItem
          key={key}
          image={card.image}
          imageAlt={card.title}
          title={card.title}
          text={card.text}
          icon={card.icon}
        />
      ))}
    </CardRow>
  )
}

export default WhatWeDoCards
